export const EDITOR_COLORS = [
  {
    value: 'white',
    hex: '#FFFFFF',
  },
  {
    value: 'black',
    hex: '#000000',
  },
  {
    value: 'red',
    hex: '#F31260',
  },
  {
    value: 'blue',
    hex: '#006FEE',
  },
  {
    value: 'purple',
    hex: '#7828C8',
  },
  {
    value: 'green',
    hex: '#17C964',
  },
  {
    value: 'pink',
    hex: '#FF4ECD',
  },
  {
    value: 'yellow',
    hex: '#F5A524',
  },
  {
    value: 'cyan',
    hex: '#7EE7FC',
  },
  {
    value: 'zinc',
    hex: '#71717A',
  },
] as const;

export const EDITOR_COLOR_HEX = {
  white: '#FFFFFF',
  black: '#000000',
  red: '#F31260',
  blue: '#006FEE',
  purple: '#7828C8',
  green: '#17C964',
  pink: '#FF4ECD',
  yellow: '#F5A524',
  cyan: '#7EE7FC',
  zinc: '#71717A',
} as const;
